<template>
  <div v-if="show" id="survey-banner" class="survey-banner">
    <a :href="url" class="survey-banner__link" target="_blank" rel="noopener">
      <img
        src="@/assets/img/sp/survey/bnr-survey.png"
        width="1065"
        height="193"
        alt="アンケート実施中 100名様に1000円が抽選で当たる アンケートはこちら"
        class="survey-banner__image"
      />
    </a>
  </div>
</template>

<script>
// SPA内のページ遷移で本コンポーネントは都度再生成されるため、直前の判定結果をモジュールスコープに保持する。
// 再取得は毎回行うが、この値を初期表示に使うことで、表示後のレイアウト変動を防ぐ。
let cachedShow = null;

export default {
  name: "SurveyBanner",
  data() {
    return {
      show: false,
      url: "https://docs.google.com/forms/d/e/1FAIpQLSfKbQysR6jXkqbOl7dR_EPPn_kbJT2_fFsOJFvhrx0OavvIrA/viewform",
      envBaseTmp: process.env.VUE_APP_TMP_S3_BASE_URL,
    };
  },
  watch: {
    // 非同期でバナーが表示された場合、DOM生成後に監視を開始する
    show(value) {
      if (value) {
        this.$nextTick(() => {
          this.observe();
        });
      } else {
        this.disconnect();
      }
    },
  },
  created() {
    this.checkDisplay();
  },
  mounted() {
    this.observe();
  },
  beforeDestroy() {
    this.disconnect();
  },
  methods: {
    // ページ遷移時（created）とタブ切替時（親からの呼び出し）に実行する。
    // 日付変更やJSON差し替えに追従させるため、判定は毎回やり直す。
    checkDisplay() {
      // プレビュー時は実施日判定を行わず常に表示する（実施日以外の表示確認用）
      const query = this.$route.query;
      if (query.preview !== undefined) {
        this.show = true;
        return;
      }
      // 取得済みの結果があれば先に同期反映しておき、再取得完了までの間もバナーを出したままにする
      if (cachedShow !== null) {
        this.show = cachedShow;
      }
      // 取得中の重複リクエストは抑止する（完了時に同じ結果が反映されるため取りこぼしは無い）
      if (this.fetching) return;
      this.checkSurveyDay();
    },
    async checkSurveyDay() {
      this.fetching = true;
      await this.$axios
        .get(`${this.envBaseTmp}header_link.json?` + new Date().getTime())
        .then((response) => {
          const today = new Date();
          const checkSurveyDisplay = (element) => {
            const surveyDay = new Date(element);
            return (
              today.getFullYear() === surveyDay.getFullYear() &&
              today.getMonth() === surveyDay.getMonth() &&
              today.getDate() === surveyDay.getDate()
            );
          };
          cachedShow = response.data.some(checkSurveyDisplay);
          this.show = cachedShow;
          this.fetching = false;
        })
        .catch((err) => {
          console.log(err);
          this.fetching = false;
        });
    },
    // バナーは画面幅に応じて高さが変わる（355px幅で64px、1060px幅で192px）。
    // 高さが変わると各ページのタブ固定しきい値がずれるため、合成scrollを投げて再計算させる。
    observe() {
      if (this.observer) return;
      const banner = document.getElementById("survey-banner");
      if (!banner) return;
      if (typeof ResizeObserver === "undefined") {
        // 非対応環境では高さ確定時に1回だけ通知する（以降は実スクロールで追従）
        window.dispatchEvent(new Event("scroll"));
        return;
      }
      // 監視開始時にも発火するため、初期計算も兼ねる
      this.observer = new ResizeObserver(() => {
        window.dispatchEvent(new Event("scroll"));
      });
      this.observer.observe(banner);
    },
    disconnect() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },
  },
};
</script>
